module.exports = __webpack_public_path__ + "media/images/electrical-wrap-2-052c451f0fd9cc821e721902927a12d9.jpg";